import * as React from 'react';

export function SvgMicrosoftOneNote(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_250)">
        <path
          d="M17.3488 21H7.50275C7.03241 21 6.65112 20.6311 6.65112 20.176V3.82395C6.65112 3.36889 7.03241 3 7.50275 3H21.1483C21.6187 3 22 3.36889 22 3.82395V7.5L17.3488 21Z"
          fill="#CA64EA"
        />
        <path
          d="M22 12L19.6745 13.35L17.3489 12V7.5H22L22 12Z"
          fill="#AE4BD5"
        />
        <path
          d="M22 16.5L19.6745 17.85L17.3489 16.5V12H22V16.5Z"
          fill="#9332BF"
        />
        <path
          d="M17.3489 16.5H22V20.1563C22 20.6222 21.6096 21 21.1279 21H17.3489V16.5Z"
          fill="#7719AA"
        />
        <path
          opacity="0.2"
          d="M12.3102 6.60001H6.65112V17.85H12.3102C12.7804 17.8485 13.1612 17.4801 13.1627 17.0252V7.42485C13.1612 6.96992 12.7804 6.60149 12.3102 6.60001Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M11.8451 7.04999H6.65112V18.3H11.8451C12.3153 18.2985 12.6961 17.9301 12.6976 17.4751V7.87484C12.6961 7.4199 12.3153 7.05147 11.8451 7.04999Z"
          fill="black"
        />
        <path
          opacity="0.5"
          d="M11.8451 7.04999H6.65112V17.4H11.8451C12.3153 17.3985 12.6961 17.0301 12.6976 16.5751V7.87484C12.6961 7.4199 12.3153 7.05147 11.8451 7.04999Z"
          fill="black"
        />
        <path
          opacity="0.5"
          d="M11.38 7.04999H6.65112V17.4H11.38C11.8502 17.3985 12.231 17.0301 12.2325 16.5751V7.87484C12.231 7.4199 11.8502 7.05147 11.38 7.04999Z"
          fill="black"
        />
        <path
          d="M2.85256 7.04999H11.38C11.8509 7.04999 12.2326 7.41929 12.2326 7.87484V16.1251C12.2326 16.5807 11.8509 16.95 11.38 16.95H2.85256C2.38171 16.95 2 16.5807 2 16.1251V7.87484C2 7.41929 2.38171 7.04999 2.85256 7.04999Z"
          fill="url(#paint0_linear_14_250)"
        />
        <path
          d="M4.80273 9.31891H5.95855L8.22971 12.8739C8.33297 13.0332 8.41049 13.1615 8.46227 13.2587H8.47716C8.44906 13.0167 8.43788 12.7731 8.44367 12.5297V9.31891H9.42972V14.6811H8.34785L5.99156 11.0276C5.91176 10.907 5.84148 10.7808 5.78133 10.65H5.76273C5.78648 10.9161 5.79626 11.1831 5.79203 11.4501V14.6811H4.80273V9.31891Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_14_250"
          x1="3.7776"
          y1="6.40547"
          x2="10.1295"
          y2="17.7763"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8324B3" />
          <stop offset="0.5" stopColor="#7A1BAC" />
          <stop offset="1" stopColor="#621197" />
        </linearGradient>
        <clipPath id="clip0_14_250">
          <rect
            width="20"
            height="18"
            fill="white"
            transform="translate(2 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
